import { Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import CircularProgress from '@mui/material/CircularProgress';
import React from 'react';
import './App.css';
import useApolloClient from './common/hooks/use-apollo-client';

import AuthProvider from './components/Auth/AuthProvider';
import ErrorMessage from './common/components/ErrorMessage';
import history from './common/helpers/history';
import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider } from '@mui/material';
import Header from './components/Header/Header'

import { PaginationContainer } from "./components/PaginationContainer/PaginationContainer";


const App = () => {
  const mode = 'light';

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          secondary: {
            main: '#264c62',
          },
          text: {
            primary: '#264c62',
          },
          mode,
        },
      }),
    [mode],
  );

  const { loading, error, client } = useApolloClient();

 
  if (loading) {
    return <CircularProgress />;
  }

  if (error || !client) {
    return <ErrorMessage message={error?.message || 'An error occurred'} />;
  }

  return (
    <Router history={history}>
      <ApolloProvider client={client}>
        <AuthProvider>
        <ThemeProvider theme={theme}>
        <CssBaseline/>
          <Header />
          <PaginationContainer />
       </ThemeProvider>
        </AuthProvider>
      </ApolloProvider>
    </Router>
  );
};

export default App;

